(function () {
  function init(scope) {
    scope.querySelectorAll('.buioch-business-nav').forEach(function (nav) {
      if (nav.dataset.businessReady) return;
      var menu = nav.querySelector('.buioch-business-dropdown');
      var toggle = nav.querySelector('.buioch-business-toggle');
      if (!menu || !toggle) return;
      nav.dataset.businessReady = 'true';
      var controller = new AbortController();
      var options = { signal: controller.signal };
      var closeTimer;
      var isOpen = false;

      function setOpen(open) {
        clearTimeout(closeTimer);
        isOpen = open;
        nav.dataset.businessOpen = String(open);
        nav.classList.toggle('nav-hover', open);
        toggle.setAttribute('aria-expanded', String(open));
        menu.inert = !open;
        if (open) nav.closest('.sticky-header')?.classList.remove('sticky-header-transformed');
      }

      function closeSoon() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          if (!nav.matches(':hover') && !menu.matches(':hover') && !nav.contains(document.activeElement)) setOpen(false);
        }, 450);
      }

      function openOnHover(event) {
        if (event.pointerType !== 'touch') setOpen(true);
      }

      setOpen(false);
      nav.addEventListener('pointerenter', openOnHover, options);
      menu.addEventListener('pointerenter', openOnHover, options);
      nav.addEventListener('pointerleave', closeSoon, options);
      menu.addEventListener('pointerleave', closeSoon, options);
      nav.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!nav.contains(document.activeElement)) setOpen(false);
        }, 0);
      }, options);
      toggle.addEventListener('click', function () { setOpen(!isOpen); }, options);
      nav.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !isOpen) return;
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        toggle.focus();
      }, { capture: true, signal: controller.signal });
      document.addEventListener('pointerdown', function (event) {
        if (!nav.contains(event.target)) setOpen(false);
      }, options);
      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target.contains(nav)) return;
        clearTimeout(closeTimer);
        controller.abort();
      }, options);
    });

    scope.querySelectorAll('.buioch-business-mobile').forEach(function (nav) {
      if (nav.dataset.businessReady) return;
      var header = nav.querySelector('.mobile-nav__has-sublist');
      var menu = nav.querySelector('.mobile-nav__sublist');
      var openButton = nav.querySelector('.mobile-nav__toggle-open');
      var closeButton = nav.querySelector('.mobile-nav__toggle-close');
      if (!header || !menu || !openButton || !closeButton) return;
      nav.dataset.businessReady = 'true';

      function sync() {
        var expanded = header.classList.contains('mobile-nav--expanded');
        openButton.setAttribute('aria-expanded', String(expanded));
        closeButton.setAttribute('aria-expanded', String(expanded));
        menu.inert = !expanded;
        if (document.activeElement === openButton || document.activeElement === closeButton) {
          (expanded ? closeButton : openButton).focus();
        }
      }

      sync();
      new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
      nav.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !header.classList.contains('mobile-nav--expanded')) return;
        event.preventDefault();
        event.stopPropagation();
        header.classList.remove('mobile-nav--expanded');
        sync();
        openButton.focus();
      }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
